import { Api } from 'models/services/api';
import { CreateHeadquartersQuery } from 'models/services/graphql';

import { HeadquartersData, HeadquartersDataToSave } from '../index';

type DataToCreate = {
  brandId: string;
  input: HeadquartersDataToSave;
};

const RequestQuery = `
  mutation CreateHeadquarters($brandId: ID!, $input: HeadquartersInput!) {
    ${CreateHeadquartersQuery}
  }
`;

type ResponseData = {
  data: {
    createHeadquarters: HeadquartersData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: HeadquartersData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createHeadquarters;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };